export function generateColorFromIndex(index: number): string {
  const hue = (index * 137) % 360;
  const color = `hsl(${hue},75%,56%)`;
  return color;
}
